/* eslint-disable jsx-a11y/anchor-is-valid */
import {SnackbarProvider} from 'notistack'
import {FC, useEffect, useState} from 'react'
import {Column} from 'react-table'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {RatioOccupancyCostumerData} from '../../../../models/reports.model'
import moment from 'moment'
import {getSnackBar, getSnackBarToast} from '../../../../../../util/snackBar'
import {
  getRatioOccupancyByCustomerCSVService,
  getRatioOccupancyByCustomerPDFService,
  getRatioSalesDeOccupancyByCustomerExcelService,
} from '../../../../services/ratio.service'

interface Props {
  datos: RatioOccupancyCostumerData[]
  loading: boolean
  formValue: any
  getOccupancy: (data: any) => void
  total: number
}

const TableReportRatioOccupancyByCustomer: FC<Props> = ({
  datos,
  loading,
  getOccupancy,
  total,
  formValue,
}) => {
  const {setPagination, pagination} = useKTable()
  const [isDownloadXLS, setIsDownloadXLS] = useState<boolean>(false)
  const [isDownloadCSV, setIsDownloadCSV] = useState<boolean>(false)
  const [isDownloadPDF, setIsDownloadPDF] = useState<boolean>(false)

  ///
  ///
  useEffect(() => {
    getOccupancy({pageNumber: pagination.currentPage, size: pagination.perPage})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    setPagination({...pagination, totalResults: total})
  }, [total])

  const columns: Column<RatioOccupancyCostumerData>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} title='Campamento' />,
      accessor: 'CampamentoNombre',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Cliente' />,
      accessor: 'Cliente',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='EE.CC' />,
      accessor: 'SSEE',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Sodexo' />,
      accessor: 'Sodexo',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Camas Instaladas' />,
      accessor: 'CamasInstaladas',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Camas Calientes' />,
      accessor: 'CamasCalientes',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Capacidad Alojamiento' />,
      accessor: 'CapacidadAlojamiento',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Total Ocupadas' />,
      accessor: 'Total',
    },
{
      Header: (props) => <KTableHeader tableProps={props} title='Total Reservado' />,
      accessor: 'TotalRES',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Total Disponibles' />,
      accessor: 'Diferencia',
    },
  ]

  const handleExportXLS = async () => {
    try {
      setIsDownloadXLS(true)
      const response = await getRatioSalesDeOccupancyByCustomerExcelService(formValue)
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Ratios Ocupabilidad-${moment().format('DD/MM/YY HH:mm').toString()}.xlsx` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setIsDownloadXLS(false)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
    } catch (error) {
      setIsDownloadXLS(false)
      getSnackBarToast('Hubo un error al descargar', 'error')
    }
  }
  const handleExportCSV = async () => {
    try {
      setIsDownloadCSV(true)
      const response = await getRatioOccupancyByCustomerCSVService(formValue)
      const blob = new Blob([response.data], {
        type: 'application/pdf',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Ratios Ocupabilidad-${moment().format('DD/MM/YY HH:mm').toString()}.csv` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
      setIsDownloadCSV(false)
    } catch (error) {
      setIsDownloadCSV(false)
      getSnackBarToast('Hubo un error al descargar', 'error')
      //
    }
  }
  const handleExportPDF = async () => {
    try {
      setIsDownloadPDF(true)
      const response = await getRatioOccupancyByCustomerPDFService(formValue)
      const blob = new Blob([response.data], {
        type: 'text/csv',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `Ratios Ocupabilidad-${moment().format('DD/MM/YY HH:mm').toString()}.pdf` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setIsDownloadPDF(false)
      getSnackBarToast('Se descargó el documento con éxito', 'success')
    } catch (error) {
      setIsDownloadPDF(false)
      getSnackBarToast('Hubo un error al descargar', 'error')
    }
  }

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='d-flex justify-content-end p-2 me-5'>
          <button
            type='button'
            className='btn btn-success me-3'
            disabled={datos.length < 1 || isDownloadXLS}
            onClick={handleExportXLS}
          >
            {isDownloadXLS && (
              <div className='icon-container'>
                <i className='loader'></i>
              </div>
            )}
            Descargar Excel
          </button>
          <button
            type='button'
            className='btn btn-success me-3'
            disabled={datos.length < 1 || isDownloadCSV}
            onClick={handleExportCSV}
          >
            {isDownloadCSV && (
              <div className='icon-container'>
                <i className='loader'></i>
              </div>
            )}
            Descargar CSV
          </button>
          <button
            type='button'
            className='btn btn-success me-3'
            disabled={datos.length < 1 || isDownloadPDF}
            onClick={handleExportPDF}
          >
            {isDownloadPDF && (
              <div className='icon-container'>
                <i className='loader'></i>
              </div>
            )}
            Descargar PDF
          </button>
        </div>

        {loading ? <KTableLoading title='Cargando...' /> : null}
        <KTable data={datos} columns={columns} />
      </KTCard>
    </>
  )
}

const TableReportRatioOccupancyByCustomerWrapper: FC<Props> = ({
  datos,
  loading,
  getOccupancy,
  formValue,
  total,
}) => {
  return (
    <KTableProvider>
      <TableReportRatioOccupancyByCustomer
        datos={datos}
        loading={loading}
        getOccupancy={getOccupancy}
        formValue={formValue}
        total={total}
      />
      <SnackbarProvider />
    </KTableProvider>
  )
}

export {TableReportRatioOccupancyByCustomerWrapper}
